/**
 * Created by PuTi(编程即菩提) 10/11/17.
 */
var nb = require('../../../../core/js/nb');
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        btnCancel: require('../button/Button'),
        btnConfirm: require('../button/Button')
    },
    method: {
        init: function () {
            this.setOpts({
                title: '',//confirm
                btnCancel: {
                    btnCls: 'btn btn-default cancel',
                    text: 'Cancel'
                },
                btnConfirm: {
                    btnCls: 'btn btn-primary confirm',
                    text: 'Confirm'
                }
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/nb/bs3/js/model/modal/Confirm.js
// module id = 16
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32